import {computed} from 'vue';
import EnvironmentService from '@/env/EnvironmentService';
import AuthService from '@/modules/user/AuthService';
import {OrganisationId} from '@/models/enums/OrganisationId';
import { useSimulationStore } from './services/SimulationStore';

const permittedOrganisations: readonly OrganisationId[] = [
  OrganisationId.LENDI,
  OrganisationId.FINAMAX,
  OrganisationId.DSA,
] as const;

const isNewCalculatorAvailable = (): boolean =>
  Boolean(AuthService.User?.isActive && (EnvironmentService.Environment.isAppDomain().NESTO_RO ||
    permittedOrganisations.includes(AuthService.User?.organisationId!) ||
    EnvironmentService.Environment.isPreprodOrDev));

export const useCalculatorVersion = () => {
  const store = useSimulationStore();
  const isNewMortgageComparator = computed(() =>
    store.isMortgage && EnvironmentService.Environment.isAppDomain().LENDI_PL
  );

  return {
    isNewCalculatorAvailable,
    isNewMortgageComparator,
  };
};
